document.addEventListener('DOMContentLoaded', function () {

  /* =========================================================
     GALLERY — thumbs + dots control which slide is active
     ========================================================= */
  var slides = document.querySelectorAll('.product-gallery__slide');
  var thumbs = document.querySelectorAll('.product-gallery__thumb');
  var dots = document.querySelectorAll('.product-gallery__dot');

  function goToSlide(index) {
    slides.forEach(function (slide) {
      var match = slide.getAttribute('data-slide') === String(index);
      slide.classList.toggle('product-gallery__slide--active', match);
    });
    thumbs.forEach(function (thumb) {
      var match = thumb.getAttribute('data-slide') === String(index);
      thumb.classList.toggle('product-gallery__thumb--active', match);
      thumb.setAttribute('aria-selected', match ? 'true' : 'false');
    });
    dots.forEach(function (dot) {
      var match = dot.getAttribute('data-slide') === String(index);
      dot.classList.toggle('product-gallery__dot--active', match);
      dot.setAttribute('aria-selected', match ? 'true' : 'false');
    });
  }

  thumbs.forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      goToSlide(thumb.getAttribute('data-slide'));
    });
  });

  dots.forEach(function (dot) {
    dot.addEventListener('click', function () {
      goToSlide(dot.getAttribute('data-slide'));
    });
  });

  /* basic swipe support on mobile */
  var slidesWrap = document.querySelector('.product-gallery__slides');
  if (slidesWrap) {
    var touchStartX = 0;
    slidesWrap.addEventListener('touchstart', function (e) {
      touchStartX = e.changedTouches[0].clientX;
    }, { passive: true });

    slidesWrap.addEventListener('touchend', function (e) {
      var diff = e.changedTouches[0].clientX - touchStartX;
      if (Math.abs(diff) < 40) return;
      var current = document.querySelector('.product-gallery__slide--active');
      var currentIndex = parseInt(current.getAttribute('data-slide'), 10);
      var total = slides.length;
      var nextIndex = diff < 0
        ? (currentIndex + 1) % total
        : (currentIndex - 1 + total) % total;
      goToSlide(nextIndex);
    }, { passive: true });
  }

  /* =========================================================
     ACCORDION — open one panel at a time, smooth height
     ========================================================= */
  var accordionItems = document.querySelectorAll('.accordion__item');

  accordionItems.forEach(function (item) {
    var trigger = item.querySelector('.accordion__trigger');
    var panel = item.querySelector('.accordion__panel');

    trigger.addEventListener('click', function () {
      var isOpen = item.classList.contains('accordion__item--open');

      accordionItems.forEach(function (other) {
        other.classList.remove('accordion__item--open');
        other.querySelector('.accordion__trigger').setAttribute('aria-expanded', 'false');
        other.querySelector('.accordion__panel').style.maxHeight = null;
      });

      if (!isOpen) {
        item.classList.add('accordion__item--open');
        trigger.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
      }
    });
  });

  /* =========================================================
     REVIEWS SLIDER — mobile only
     ========================================================= */
  (function () {
    var track   = document.getElementById('reviewsTrack');
    if (!track) return;

    var dots    = document.querySelectorAll('.reviews__dot');
    var cards   = document.querySelectorAll('.reviews__card');
    var total   = cards.length;
    var current = 0;
    var startX  = 0;
    var DESKTOP_BP = 1024;

    function isDesktop() {
      return window.innerWidth >= DESKTOP_BP;
    }

    function goTo(index) {
      if (isDesktop()) return;
      if (index < 0) index = 0;
      if (index >= total) index = total - 1;
      current = index;
      track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (dot, i) {
        dot.classList.toggle('reviews__dot--active', i === current);
      });
    }

    dots.forEach(function (dot) {
      dot.addEventListener('click', function () {
        goTo(parseInt(dot.getAttribute('data-index'), 10));
      });
    });

    track.addEventListener('touchstart', function (e) {
      if (isDesktop()) return;
      startX = e.touches[0].clientX;
    }, { passive: true });

    track.addEventListener('touchend', function (e) {
      if (isDesktop()) return;
      var diff = startX - e.changedTouches[0].clientX;
      if (Math.abs(diff) < 40) return;
      goTo(diff > 0 ? current + 1 : current - 1);
    }, { passive: true });

    track.addEventListener('mousedown', function (e) {
      if (isDesktop()) return;
      startX = e.clientX;
    });

    window.addEventListener('mouseup', function (e) {
      if (isDesktop()) return;
      var diff = startX - e.clientX;
      if (Math.abs(diff) < 40) return;
      goTo(diff > 0 ? current + 1 : current - 1);
    });

    window.addEventListener('resize', function () {
      if (isDesktop()) {
        track.style.transform = '';
      } else {
        goTo(current);
      }
    });

    goTo(0);
  })();

  /* =========================================================
     MARQUEE BANNER — right to left scroll
     ========================================================= */
  (function () {
    var list = document.querySelector('.marquee-banner__list');
    if (!list) return;

    var origItems = Array.from(list.querySelectorAll('.marquee-banner__item'));
    var posX = 0;
    var rafId = null;
    var speed = 1;
    var totalWidth = 0;

    function cloneItems() {
      list.querySelectorAll('[aria-hidden="true"]').forEach(function (el) {
        el.remove();
      });

      var trackWidth = list.parentElement.offsetWidth;

      while (list.scrollWidth < trackWidth * 2) {
        origItems.forEach(function (item) {
          var clone = item.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          list.appendChild(clone);
        });
      }

      totalWidth = list.scrollWidth / 2;
      posX = totalWidth;
      list.style.transform = 'translateX(' + posX + 'px)';
    }

    function tick() {
      posX -= speed;
      if (posX <= -totalWidth) posX = 0;
      list.style.transform = 'translateX(' + posX + 'px)';
      rafId = requestAnimationFrame(tick);
    }

    function start() {
      if (rafId) cancelAnimationFrame(rafId);
      rafId = requestAnimationFrame(tick);
    }

    function stop() {
      cancelAnimationFrame(rafId);
      rafId = null;
    }

    var banner = document.querySelector('.marquee-banner');
    if (banner) {
      banner.addEventListener('mouseenter', stop);
      banner.addEventListener('mouseleave', start);
    }

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(function () {
        stop();
        cloneItems();
        start();
      }, 200);
    });

    cloneItems();
    start();
  })();
 (function () {
      var section = document.getElementById('faq-{{ section.id }}');
      if (!section || section.dataset.faqInit) return;
      section.dataset.faqInit = 'true';

      var items = section.querySelectorAll('.faq__item');
      var DESKTOP_BREAKPOINT = 990;
      var hasUserInteracted = false;

      function setItemState(item, open) {
        var btn   = item.querySelector('.faq__question');
        var panel = item.querySelector('.faq__answer');
        var icon  = item.querySelector('.faq__icon-svg');

        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
        item.classList.toggle('faq__item--active', open);
        panel.style.maxHeight = open ? panel.scrollHeight + 'px' : null;

        if (icon) {
          icon.src = open ? icon.dataset.iconMinus : icon.dataset.iconPlus;
        }
      }

      function closeAll() {
        items.forEach(function (item) {
          setItemState(item, false);
        });
      }

      function applyDefaultState(isDesktop) {
        closeAll();
        if (isDesktop && items.length) {
          setItemState(items[0], true);
        }
      }

      // ── Click events ─────────────────────────────────────────
      items.forEach(function (item) {
        var btn = item.querySelector('.faq__question');
        btn.addEventListener('click', function () {
          hasUserInteracted = true;
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          closeAll();
          if (!isOpen) setItemState(item, true);
        });
      });

      // ── Breakpoint cross hole default state thik kora ──────────
      var mql = window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)');
      function handleBreakpointChange(e) {
        if (hasUserInteracted) return; // user click korle ar override hobe na
        applyDefaultState(e.matches);
      }

      if (mql.addEventListener) {
        mql.addEventListener('change', handleBreakpointChange);
      } else if (mql.addListener) {
        // Safari purono version fallback
        mql.addListener(handleBreakpointChange);
      }

      // ── Open panel-er height recalc resize-e (font reflow) ──────
      var resizeTimer;
      window.addEventListener('resize', function () {
        clearTimeout(resizeTimer);
        resizeTimer = setTimeout(function () {
          var activeItem = section.querySelector('.faq__item--active');
          if (activeItem) {
            var panel = activeItem.querySelector('.faq__answer');
            panel.style.maxHeight = panel.scrollHeight + 'px';
          }
        }, 150);
      });

      // ── Init ─────────────────────────────────────────────────
      applyDefaultState(mql.matches);
    })();
});